export enum EStatusBackgroundColors {
  YELLOW_COLOR_HEX = '#FFC043',
  ORANGE_COLOR_HEX = '#F77F00',
  BLUE_COLOR_HEX = '#6CB5FF',
  GREEN_COLOR_HEX = '#1CBA70',
  LIGHT_BLUE_COLOR_HEX = '#0A84FF',
  RED_COLOR_HEX = '#EB4236',
}
